import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="text-center max-w-lg">
        <div className="mb-8 border-4 border-foreground bg-white shadow-brutal-lg overflow-hidden max-w-xs mx-auto">
          <img src="/404.png" alt="404" className="w-full h-auto" />
        </div>
        <h1 className="font-display text-4xl font-bold mb-4">Halaman Tidak Ditemukan</h1>
        <p className="text-muted-foreground mb-8">Maaf, halaman yang Anda cari mungkin sudah dihapus atau salah alamat.</p>
        <Link to="/" className="inline-block border-2 border-foreground bg-primary text-white px-8 py-3 font-bold uppercase tracking-wide shadow-brutal hover:shadow-none hover:translate-x-[2px] hover:translate-y-[2px] transition-all" data-testid="notfound-home-btn">
          Kembali ke Beranda
        </Link>
      </div>
    </div>
  );
}
